exports.FeedbackFish={mounted:function(){var e=this;this.$nextTick(function(){var t=document.createElement("script");t.setAttribute("src","https://feedback.fish/ff.js?pid="+e.$props.projectId),t.defer=!0,document.head.appendChild(t)})},props:{projectId:String},render:function(){return null}};
//# sourceMappingURL=feedback-fish.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@feedback-fish/vue/dist/feedback-fish.js
// module id = 629
// module chunks = 5